import { useState, useEffect } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { toast } from "react-toastify";
import { PageContainer, DataTable, StatusBadge, Button } from "components/ui";

const AuditLogs = () => {
  const axiosPrivate = useAxiosPrivate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await axiosPrivate.get(`/api/admin/logs?page=${page}&size=15`);
      setLogs(res.data.content);
      setTotalPages(res.data.totalPages);
    } catch (_) {
      toast.error("Failed to load logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchLogs(); }, [page]);

  return (
    <PageContainer>
      <DataTable
        title="Activity logs"
        subtitle="Audit trail for platform actions"
        loading={loading}
        data={logs}
        rowKey={(l) => l.id}
        searchPlaceholder="Search action, user, target…"
        paginate={false}
        emptyTitle="No activity yet"
        columns={[
          { key: "timestamp", header: "Timestamp", render: (l) => <span className="t-muted t-mono" style={{ fontSize: 12 }}>{new Date(l.timestamp).toLocaleString()}</span> },
          { key: "action",    header: "Action",    render: (l) => <StatusBadge tone="info">{l.action}</StatusBadge> },
          { key: "performedBy", header: "User",    render: (l) => <span>{l.performedBy}</span> },
          { key: "target",    header: "Target",    render: (l) => <span className="t-mono t-muted">{l.targetType} {l.targetId}</span> },
          {
            key: "ipAddress",  header: "IP",
            render: (l) => (
              <span className="t-mono t-muted" style={{ maxWidth: 200, display: "inline-block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", verticalAlign: "bottom" }}>
                {l.ipAddress || "—"}
              </span>
            ),
          },
        ]}
        footer={
          totalPages > 1 ? (
            <div className="dt-foot">
              <span>Page <strong>{page + 1}</strong> of {totalPages}</span>
              <div style={{ display: "inline-flex", gap: 6 }}>
                <Button variant="ghost" size="sm" disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))}>‹ Prev</Button>
                <Button variant="ghost" size="sm" disabled={page >= totalPages - 1} onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}>Next ›</Button>
              </div>
            </div>
          ) : null
        }
      />
    </PageContainer>
  );
};

export default AuditLogs;
